import React, { useEffect, useState } from "react";
import { WbSunny, NightsStay, WbCloudy, BeachAccess } from "@mui/icons-material";
import { AccessTime, Event } from "@mui/icons-material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export const DashboardHeading = () => {
  const [currentTime, setCurrentTime] = useState("");
  const [username, setUsername] = useState("");
  const [greeting, setGreeting] = useState("");
  const [greetingIcon, setGreetingIcon] = useState(null);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Define background gradient immediately based on dark mode state
  const getGradientBackground = (hour) => {
    if (hour >= 5 && hour < 12) {
      return isDarkMode
        ? "linear-gradient(135deg, #FF7043, #D84B16)"
        : "linear-gradient(135deg, #FF9800, #F57C00)";
    } else if (hour >= 12 && hour < 17) {
      return isDarkMode
        ? "linear-gradient(135deg, #3B5A75, #2C4F68)"
        : "linear-gradient(135deg, #66B2FF, #4682B4)";
    } else if (hour >= 17 && hour < 21) {
      return isDarkMode
        ? "linear-gradient(135deg, #660000, #3B0000)"
        : "linear-gradient(135deg, #FF6347, #B22222)";
    } else {
      return isDarkMode
        ? "linear-gradient(135deg, #1C1C1C, #121212)"
        : "linear-gradient(135deg, #1E2A47, #000000)";
    }
  };

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      const userInfo = JSON.parse(storedUserInfo);
      setUsername(userInfo.name);
    }

    const updateTime = () => {
      const now = new Date();
      const hour = now.getHours();
      let newGreeting = "";
      let newGreetingIcon = null;

      if (hour >= 5 && hour < 12) {
        newGreeting = "Good Morning";
        newGreetingIcon = <WbSunny fontSize="small" />;
      } else if (hour >= 12 && hour < 17) {
        newGreeting = "Good Afternoon";
        newGreetingIcon = <WbCloudy fontSize="small" />;
      } else if (hour >= 17 && hour < 21) {
        newGreeting = "Good Evening";
        newGreetingIcon = <BeachAccess fontSize="small" />;
      } else {
        newGreeting = "Good Night";
        newGreetingIcon = <NightsStay fontSize="small" />;
      }

      setGreeting(newGreeting);
      setGreetingIcon(newGreetingIcon);

      const formattedDate = now.toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      });

      const formattedTime = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      setCurrentTime(`${formattedDate} | ${formattedTime}`);
    };

    const timeInterval = setInterval(updateTime, 1000);
    return () => clearInterval(timeInterval);
  }, []);

  return (
    <Box
      className="sticky top-0 ml-auto w-full border-2 border-solid shadow-lg text-white"
      sx={{
        borderRadius: "15px",
        background: getGradientBackground(new Date().getHours()),
        transition: "background 0.5s ease-in-out",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: { xs: 0.5, sm: 2 },
        p: { xs: 1.5, sm: "15px 20px" },
      }}
    >
      {/* Greeting & Time */}
      <div className="flex flex-wrap items-center space-x-2 sm:space-x-4">
        <div className="flex items-center space-x-2 text-base font-semibold sm:text-lg">
          {greetingIcon}
          <span>{greeting}, {username || "User"}</span>
        </div>
      </div>

      {/* Date & Time Section */}
      <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-xs font-medium sm:text-sm">
        <div className="flex items-center space-x-1">
          <Event fontSize="small" />
          <span>{currentTime.split("|")[0]}</span>
        </div>
        <div className="flex items-center space-x-1">
          <AccessTime fontSize="small" />
          <span>{currentTime.split("|")[1]}</span>
        </div>
      </div>
    </Box>
  );
};

export default DashboardHeading;
